export default "__VITE_ASSET__C09tqBX0__"